// Marca de agua decorativa 自働 (jidōka) — evoca el nombre del copiloto y de la
// empresa. Puramente ornamental: absolute, aria-hidden, opacidad muy baja y
// pointer-events-none para no interferir con el scroll ni el texto. Se dibuja
// DETRÁS del contenido (el contenido va con `relative z-10` en el drawer).

export function MarcaAguaKanji() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 z-0 select-none overflow-hidden"
    >
      <span className="absolute -right-6 top-24 font-serif text-[11rem] leading-none text-fg opacity-[0.03]">
        自働
      </span>
    </div>
  );
}
